import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './Values.css';
import integrity from '../../../images/newIcon/Integrity 1.svg';
import teamwork from '../../../images/newIcon/Teamwork 1.svg';
import focus from '../../../images/newIcon/client-focus.svg';
import innovation from '../../../images/newIcon/Innovation 1.svg';
import implementation from '../../../images/newIcon/Implementation 1.svg';
import performance from '../../../images/newIcon/Performance 1.svg';
import partnership from '../../../images/newIcon/Partnership 1.svg';

function Values() {
    return (
        <>
            <section>
                <Container>
                    <div className='vision-main'>
                        <div className='section-header'>
                            <h2>Vision</h2>
                            <p>JM Financial will be the most trusted partner for every stakeholder in the financial world</p>
                        </div>
                        <div className='vision-detail'>
                            <Row>
                                {/*  <Col sm={12} md={6}>
                                            <div className='vision-img'>
                                                { <img src={AboutusVision} alt='vision-banner' className='img-fluid'></img> }
                                            </div>
                                        </Col> */}
                                <Col sm={12} md={12}>
                                    <div className='vision-data'>
                                        <h3>
                                            <strong className='jmmf-vision'>We believe:</strong></h3>
                                        <ul>
                                            <li>Earning trust is a process (it can be gained and lost every day!)</li>
                                            <li>Sharing trust creates great teams (whether between employees or between organisations)</li>
                                            <li>Being trustworthy is the most efficient way of generating and retaining long-term business</li>
                                            <li>Self–trust is the starting point of trusting others</li>
                                        </ul>
                                        <p>At JM Financial Mutual Fund, we aspire to create wealth for all our investors.</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <Row>
                        <Col sm={12} md={12}>
                            <div className='section-header'>
                                <h2>Values</h2>
                                <p>We have always sought to be a value-driven organisation, where our values direct our growth and success</p>
                            </div>

                            <div className='values-main'>
                                <div className='values-inner textalign-center'>
                                    <div className='div1-values'>
                                        <img src={integrity} alt='' aria-hidden='true' className='img-fluid' height={60} width={60}></img>
                                        <h3>Integrity </h3>
                                    </div>
                                    <div className='div2-values'>
                                        <p className='textalign-left'>Integrity is fundamental to our business. We adhere to moral and ethical principles in everything we do as professionals, colleagues and corporate citizens. Our reputation based on our high standards of integrity is invaluable.</p>
                                    </div>
                                </div>
                                <div className='values-inner textalign-center'>
                                    <div className='div1-values'>
                                        <img src={teamwork} alt='' aria-hidden='true' className='img-fluid' height={60} width={60}></img>
                                        <h3>Teamwork </h3>
                                    </div>
                                    <div className='div2-values'>
                                        <p className='textalign-left'>We believe extensive teamwork is what makes it possible for us to work together towards a common goal. We value and respect each individual's commitment to group effort.</p>
                                    </div>
                                </div>
                                <div className='values-inner textalign-center'>
                                    <div className='div1-values'>
                                        <img src={focus} alt='' aria-hidden='true' className='img-fluid' height={60} width={60}></img>
                                        <h3>Client Focus</h3>
                                    </div>
                                    <div className='div2-values'>
                                        <p className='textalign-left'>We always put the interest of our clients before our own. We understand our client needs, seek new opportunities for them, address them and deliver unique solutions as per their expectations. The success of our clients is the biggest reward for us.</p>
                                    </div>
                                </div>
                                <div className='values-inner textalign-center'>
                                    <div className='div1-values'>
                                        <img src={innovation} alt='' aria-hidden='true' className='img-fluid' height={60} width={60}></img>
                                        <h3>Innovation </h3>
                                    </div>
                                    <div className='div2-values'>
                                        <p className='textalign-left'> We understand our clients' needs and develop solutions for the most complex or the simplest, the biggest or the smallest financial transactions, whether for individuals or institutions. Creativity and innovation are key factors to everything we do. We encourage new ideas which help us address unique opportunities.</p>
                                    </div>
                                </div>
                                <div className='values-inner textalign-center'>
                                    <div className='div1-values'>
                                        <img src={implementation} alt='' aria-hidden='true' className='img-fluid' height={60} width={60}></img>
                                        <h3> Implementation</h3>
                                    </div>
                                    <div className='div2-values'>
                                        <p className='textalign-left'> Our expertise, experience and our continuous focus on the quality of execution ensures effective implementation of our strategies.</p>
                                    </div>
                                </div>
                                <div className='values-inner textalign-center'>
                                    <div className='div1-values'>
                                        <img src={performance} alt='' aria-hidden='true' className='img-fluid' height={60} width={60}></img>
                                        <h3> Performance </h3>
                                    </div>
                                    <div className='div2-values'>
                                        <p className='textalign-left'>We believe in development of our people and continuously hone our skills, setting higher targets of performance for ourselves. We strive to attract, develop and retain the best talent. We recognize and reward talent based on merit.</p>
                                    </div>
                                </div>
                                <div className='values-inner textalign-center'>
                                    <div className='div1-values'>
                                        <img src={partnership} alt='' aria-hidden='true' className='img-fluid' height={60} width={60}></img>
                                        <h3>Partnership</h3>
                                    </div>
                                    <div className='div2-values'>
                                        <p className='textalign-left'>Our relationships with all our stakeholders reflect our spirit of partnership. Clients see us as trusted advisors, shareholders see us as partners and employees see us as family. We respect, trust and support all our stakeholders.</p>
                                    </div>
                                </div>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default Values;